import type { InstagramPost } from "@/types/instagram";

export const instagramHandle = "thequalityexports";
export const instagramUrl = `https://www.instagram.com/${instagramHandle}/`;

export const instagramPosts: InstagramPost[] = [
    {
        id: "ig-01",
        permalink: `${instagramUrl}p/aaa111/`,
        imageSrc: "/instagram/post-01.jpg",
        imageAlt: "Hand-hammered brass vessel resting on raw linen",
        caption:
            "Every curve begins as a flat sheet. Six hours of hand-hammering later — Plate No. 014.",
        mediaType: "IMAGE",
        timestamp: "2025-01-18T09:20:00Z",
        likes: 2184,
        comments: 63,
    },
    {
        id: "ig-02",
        permalink: `${instagramUrl}p/bbb222/`,
        imageSrc: "/instagram/post-02.jpg",
        imageAlt: "Artisan applying antique patina to a metal surface",
        caption: "Patina is patience made visible.",
        mediaType: "IMAGE",
        timestamp: "2025-01-14T12:05:00Z",
        likes: 1547,
        comments: 41,
    },
    {
        id: "ig-03",
        permalink: `${instagramUrl}p/ccc333/`,
        imageSrc: "/instagram/post-03.jpg",
        imageAlt: "Detail of a polished bevelled edge catching light",
        caption: "The bevel — 0.8 mm of deliberate restraint.",
        mediaType: "VIDEO",
        timestamp: "2025-01-09T16:40:00Z",
        likes: 3092,
        comments: 118,
    },
    {
        id: "ig-04",
        permalink: `${instagramUrl}p/ddd444/`,
        imageSrc: "/instagram/post-04.jpg",
        imageAlt: "Finished collection arranged on a workshop bench",
        caption: "Bench day. The Moradabad atelier, first light.",
        mediaType: "CAROUSEL_ALBUM",
        timestamp: "2025-01-03T07:15:00Z",
        likes: 2760,
        comments: 87,
    },
    {
        id: "ig-05",
        permalink: `${instagramUrl}p/eee555/`,
        imageSrc: "/instagram/post-05.jpg",
        imageAlt: "Close crop of engraved maker's mark",
        caption: "Signed, not stamped.",
        mediaType: "IMAGE",
        timestamp: "2024-12-28T11:30:00Z",
        likes: 1893,
        comments: 52,
    },
    {
        id: "ig-06",
        permalink: `${instagramUrl}p/fff666/`,
        imageSrc: "/instagram/post-06.jpg",
        imageAlt: "Packaged order wrapped in unbleached cotton and twine",
        caption: "Wrapped for a client in Copenhagen.",
        mediaType: "IMAGE",
        timestamp: "2024-12-21T14:55:00Z",
        likes: 1420,
        comments: 34,
    },
];